var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacebookOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 33C8.15789 33 1 25.8421 1 17C1 8.15789 8.15789 1 17 1C25.8421 1 33 8.15789 33 17C33 25.8421 25.8421 33 17 33Z",
    stroke: "#619428",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5577 26.6842H18.4314V16.9158H21.1261L21.3787 13.6316H18.4314C18.4314 13.6316 18.4314 12.3684 18.4314 11.779C18.4314 11.0211 18.5998 10.6842 19.3577 10.6842C19.9472 10.6842 21.4629 10.6842 21.4629 10.6842V7.3158C21.4629 7.3158 19.2735 7.3158 18.7682 7.3158C15.905 7.3158 14.5577 8.57895 14.5577 11.0211C14.5577 13.1263 14.5577 13.6316 14.5577 13.6316H12.5366V16.9158H14.5577V26.6842Z",
    fill: "#619428"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookOrange);
export default __webpack_public_path__ + "static/media/facebook_orange.3f7ca05e8c0df9ab4c137d94bfe9de9b.svg";
export { ForwardRef as ReactComponent };